<template>
  <div class="flexi-container page__internal page__cookie-policy">
    <flexi-top-card
      :class="!showHeader ? 'scrolled-up-card' : ''"
      v-view="inView"
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[3].top_card"
      @button-clicked="smoothScroll"
    />

    <flexi-visible when-hidden="#top-card">
      <a @click.prevent="scroll('#top-card')">
        <div class="arrow-down">
          <span class="text" v-text="'Go to top'"></span>
          <div class="svg"></div>
        </div>
      </a>
    </flexi-visible>

    <div class="inview-bg" v-view="inView" />

    <flexi-wrapper
      v-if="inputData.internalPages"
      :inputData="inputData.internalPages[3].sections[0]"
    >
      <template v-slot:content="slotProps">
        <flexi-column
          v-for="(value, key) in slotProps.inputData.widgets"
          :key="key"
          :inputData="value"
          data-aos="fade-up"
          data-aos-duration="1500"
        />
      </template>
    </flexi-wrapper>

    <flexi-advanced-last-card
      v-if="inputData.homePage"
      :inputData="inputData.homePage.last_card"
      :navigationPages="inputData.navigationPages"
      :loadingForm="loading"
      @button-clicked="sendNewsEmail"
      data-aos="fade-up"
    >
      <template v-slot:navigation>
        <ul class="navigation-bottom">
          <li
            v-for="(value, key) in bottomNavigation"
            :key="key"
            class="navigation__item"
          >
            <a
              :href="value.href"
              :target="
                value.name === 'Home' || value.name === 'API Documentation'
                  ? ''
                  : '_blank'
              "
            >
              <span v-text="value.name" />
            </a>
          </li>
        </ul>
      </template>
    </flexi-advanced-last-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { bottomMenu } from "../static/data/bottomMenu";
import FlexiAdvancedLastCard from "../components/FlexiAdvancedLastCard.vue";

export default {
  name: "privacy-policy",
  components: {
    FlexiAdvancedLastCard
  },
  data() {
    return {
      bottomNavigation: bottomMenu
    };
  },
  mounted() {
    window.scrollTo(0, 5);
  },
  computed: {
    ...mapGetters(["inputData"])
  }
};
</script>

<style lang="scss">
// @import "~@schnapsterdog/flexi-vue/src/assets/scss/parts/_media-mixins";
</style>
